import { symbolIndexWorkerClient } from '../worker/client.js';

export function enqueueSymbolIndexTask(
  parentPath: string,
  filePath: string,
  priority: number,
  sequence?: number,
): void {
  symbolIndexWorkerClient.enqueue(parentPath, filePath, priority, sequence);
}

export function markLatestActiveSymbolIndexTask(parentPath: string, sequence: number): void {
  symbolIndexWorkerClient.markLatestActive(parentPath, sequence);
}

export function deferBackgroundSymbolIndexTasks(): void {
  symbolIndexWorkerClient.deferBackground();
}
